var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      class: [_vm.isClassHomeAndNotItemPage ? "header-home" : "header-section"],
      style: _vm.styleObject
    },
    [
      _c("div", { staticClass: "header-info" }, [
        _vm.course.COURSE_TITLE
          ? _c(
              "div",
              {
                staticClass: "title",
                class: "text-" + _vm.textColor,
                attrs: { id: "course-grades-title" }
              },
              [
                _c("span", [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.course.COURSE_TITLE) + "\n\t\t\t"
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.course.TEACHER_NAME
          ? _c("span", { class: "header-text text-" + _vm.textColor }, [
              _vm._v(_vm._s(_vm.course.TEACHER_NAME))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.details.EMAIL
          ? _c(
              "a",
              {
                class: "btn-unstyled text-" + _vm.textColor,
                attrs: { href: "mailto:" + _vm.details.EMAIL }
              },
              [
                _c("i", {
                  staticClass: "fas fa-envelope",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.classPage.Header.teacherEmail", {
                          teacher: _vm.course.TEACHER_NAME
                        })
                      ) +
                      "\n\t\t\t"
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("page-icon", _vm._b({}, "page-icon", _vm.currentIconProps, false)),
      _vm._v(" "),
      _vm.isClassHomeAndNotItemPage
        ? _c("div", {
            staticClass: "header-overlay",
            style: { backgroundColor: _vm.bgColor }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.menu.length > 0
        ? _c(
            "nav",
            {
              staticClass: "class-menu",
              attrs: { "aria-label": "Class Options" }
            },
            [
              _c("ul", { staticClass: "nav navbar-nav navbar-right" }, [
                _c("li", [
                  _c(
                    "button",
                    {
                      class: {
                        active: _vm.isMenuActive,
                        "btn-unstyled class-menu-btn text": true
                      },
                      style: "color:" + _vm.textColor + ";",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleClassNav()
                        }
                      }
                    },
                    [
                      _vm._m(0),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.classPage.Header.classPage_classMenu"
                            )
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isMenuActive,
                          expression: "isMenuActive"
                        }
                      ],
                      staticClass: "header-dropdown"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "header-dropdown-menu" },
                        [
                          _c("class-nav", {
                            attrs: {
                              course: _vm.course,
                              menu: _vm.menu,
                              "current-section": _vm.currentSection,
                              "course-content": _vm.courseContent
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "bento", attrs: { "aria-hidden": "true" } },
      [
        _c("i", { staticClass: "fas fa-ellipsis-v" }),
        _vm._v(" "),
        _c("i", { staticClass: "fas fa-ellipsis-v" }),
        _vm._v(" "),
        _c("i", { staticClass: "fas fa-ellipsis-v" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }